import React from 'react'

const SentryTestError = (props) => {
    console.log(doesNotExist)

    return <div />
}

export default SentryTestError



// WEBPACK FOOTER //
// ./resources/js/pages/SentryTestError.js